import {NgModule} from '@angular/core';
import {SharedModule} from '../../shared/shared.module';
import {ChipTypeTableComponent} from './table/chip-type-table.component';
import {ChipTypeEditComponent} from './edit/chip-type-edit.component';
import {ChipTypeCreateComponent} from './create/chip-type-create.component';

@NgModule({
  declarations: [
    ChipTypeTableComponent,
    ChipTypeEditComponent,
    ChipTypeCreateComponent
  ],
  imports: [SharedModule],
  exports: [
    ChipTypeTableComponent,
    ChipTypeEditComponent,
    ChipTypeCreateComponent
  ]
})
export class ChipTypeModule {}
